export const faqs = [
  {
    id: "faq-audience",
    question: "Who buys the kit, and who takes part?",
    answer:
      "The kit is for the person who runs the practice — a sales team leader or the owner of a small service business coaching 3–12 sellers. Your sellers are the participants. They use the printed cases, role cards and observation sheets during the session; they don't need their own copy.",
  },
  {
    id: "faq-scope",
    question: "Is this leadership or customer-service training?",
    answer:
      "No. The workshops are for practicing customer sales conversations: opening, discovery, fit, value, price, alternatives, decisions and follow-up. They don't cover manager leadership or customer-service complaint handling.",
  },
  {
    id: "faq-prep",
    question: "How much preparation does each session need?",
    answer:
      "Less than building a session yourself, but not none. Before each workshop, read the facilitator plan so you're comfortable with the wording, and print the participant pages. The cases, role cards and model responses are already written.",
  },
  {
    id: "faq-cases",
    question: "What are Case A and Case B?",
    answer:
      "Every workshop includes two complete fictional service-business cases, with scope and price. Case A is used in the timed 30-minute session. Case B is an alternative, or a way to repeat the workshop later — it isn't extra work squeezed into the same 30 minutes.",
  },
  {
    id: "faq-volumes",
    question: "Are the two volumes separate purchases?",
    answer:
      "No. The core manual comes as two volumes of five workshops each, and both are included in the same $27 one-time price, along with all five bonuses.",
  },
  {
    id: "faq-format",
    question: "What file types are included?",
    answer:
      "English-language PDFs: the facilitator manual volumes and printable participant pages. There is no video, slide deck, editable template, software or certification, and nothing physical is shipped.",
  },
  {
    id: "faq-license",
    question: "Can I share the materials?",
    answer:
      "You can print and use the participant pages with your own internal team. The kit doesn't include resale or redistribution rights.",
  },
  {
    id: "faq-remote",
    question: "Can I run the practice remotely?",
    answer:
      "Yes. The 30-minute structure works on a video call: share the participant pages with your team ahead of time, use breakout rooms for seller, buyer and observer groups, and bring everyone back for the debrief.",
  },
  {
    id: "faq-optional",
    question: "Are there optional add-ons?",
    answer:
      "The core kit is complete on its own. Two optional products are sold separately and are not part of the $27 price: the Advanced Sales Conversation Practice Lab ($29, six additional sessions) and The 12-Month Sales Practice Program ($37, twelve new workshops delivered together — not a subscription).",
  },
  {
    id: "faq-status",
    question: "Are the pages in the preview from the actual product?",
    answer:
      "Yes. The five pages in the look-inside section come directly from Sales Conversation Foundations, Volume 1. They show the session agenda, a workshop plan, role cards, a model dialogue and an observation sheet. Both volumes and all five bonuses belong to the core offer.",
  },
  {
    id: "faq-results",
    question: "Are results guaranteed?",
    answer:
      "No. The kit gives you prepared, structured practice sessions. What changes depends on your team, your market and how consistently you practice, so we don't promise revenue or conversion results.",
  },
];
